(ns frontend.ui.component.lp-portal.report.body.invest-europe.holding.new-investment.controller
  (:require
   [frontend.ui.component.lp-portal.report.controller :as report-ctl]
   [frontend.ui.component.lp-portal.report.body.invest-europe.holding.controller :refer [block-table-raw-data->editable-data
                                                                                         invest-europe-editable-data->raw-data
                                                                                         invest-europe-table-raw-data->editable-data]]))


(defn ->ui-data
  [{:keys [dynamic-data report-data] :as props}]
  {:holding-name   (get-in report-data [:holding-name])
   :reference-date (get-in report-data [:reference-date])
   :report-id      (:report-id props)
   :overview-new   {:case-overview   (report-ctl/rich-content
                                      props
                                      :case-overview-text)
                    :investment-info (->> (report-ctl/with-footnote
                                            props
                                            :investment-info-footnotes
                                            (:investment-info-new report-data))
                                          (report-ctl/with-editable-tables (merge {:fixed-columns? true
                                                                                   :fixed-labels? true} props)
                                            :investment-info-new
                                            block-table-raw-data->editable-data
                                            invest-europe-editable-data->raw-data))}
   :ownership-new (->> (report-ctl/with-footnote
                         props
                         :ownership-footnotes
                         (:ownership-new report-data))
                       (report-ctl/with-editable-tables props :ownership-new
                         invest-europe-table-raw-data->editable-data
                         invest-europe-editable-data->raw-data))
   :image-1        (report-ctl/image-content
                    props
                    :image-1-footnotes
                    (:image-1 dynamic-data))
   :logo-image-1   (report-ctl/image-content
                    props
                    :logo-image-1-footnotes
                    (:logo-image-1 dynamic-data))})
